module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQBAMAAAD+CqKmAAAALVBMVEUAAACEPSmEPSmDQCiAQCCDPSqDPSqDPSaCPSuCPSiCPimDPimDPSmDQCyDPSlgLQVaAAAADnRSTlMA36AgEO+vUGBgj2+/QDp94A4AAABnSURBVAjXY5j4Dg7CGZj1YOxnDgwMnHIQ9tMCBgYVBiMIJ4XBi+FhA1AbWAOvHMO7RwbMeiANLOveMbx7JwHUBtRQ+g7EeafMYJTC4PYOwgFqY+COg3JA2s69g3KA2ra+g3AggGwOACoNjInOHJBlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/icon-email.png
// module id = eaIa
// module chunks = 0